export const PAGEBREAK_CLASSNAME = 'pagebreak'

export const pageStyle = `

@page {
  size: A4;
  margin: 0mm auto;
}

@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}

@media all {
  .${PAGEBREAK_CLASSNAME} {
    display: none;
  }
}

@media print {
  .${PAGEBREAK_CLASSNAME} {
    display: block;
    page-break-before: always;
  }
}
`
